// extracted by mini-css-extract-plugin
module.exports = {"radioGroup":"_2Z180Q"};